module.exports = __webpack_public_path__ + "img/home_pie_chart_de.ae656cc.png";